import { Expose } from 'class-transformer';

import type OrderProduct from '../types/OrderProduct';

export default class CateringOrderSuggestion {
  @Expose() id?: string = undefined;
  @Expose() title?: string = undefined;
  @Expose() description?: string = undefined;
  @Expose() products?: OrderProduct[] = [];
  @Expose() cost?: number = undefined;

  constructor(id: string, title: string, description: string, products: OrderProduct[], cost: number) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.products = products;
    this.cost = cost;
  }
}
